module.exports = __webpack_public_path__ + "media/images/desktop/app-download-appicon-00ab9f2ec2e620e3443c1e6278f23240.png";